import TuleLakeData from "../../../../src/components/tule-lake-data.js";
import * as React from 'react';
export default {
  TuleLakeData,
  React
};